module.exports = __webpack_public_path__ + "static/img/sdk.d3f97dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sdk.png
// module id = 0254
// module chunks = 1